import { render, staticRenderFns } from "./addDepartments.vue?vue&type=template&id=ae5dae4a&scoped=true"
import script from "./addDepartments.vue?vue&type=script&lang=js"
export * from "./addDepartments.vue?vue&type=script&lang=js"
import style0 from "./addDepartments.vue?vue&type=style&index=0&id=ae5dae4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5dae4a",
  null
  
)

export default component.exports